import { StyledDecisionSupportTabs } from '@/components/decisionSupport/DecisionSupport.styled';
import { Tab } from '@mui/material';
import { FC, type SyntheticEvent, useCallback } from 'react';

export type DecisionSupportTab = {
    label: string;
};

type DecisionSupportTabsProps = {
    tabs: DecisionSupportTab[];
    activeIndex: number;
    onChange: (index: number) => void;
};

export const DecisionSupportTabs: FC<DecisionSupportTabsProps> = ({
    tabs,
    activeIndex,
    onChange,
}) => {
    const handleChange = useCallback(
        (_: SyntheticEvent, value: number) => {
            onChange(value);
        },
        [onChange],
    );

    return (
        <StyledDecisionSupportTabs value={activeIndex} onChange={handleChange}>
            {tabs.map((tab, idx) => (
                <Tab key={idx} label={tab.label} />
            ))}
        </StyledDecisionSupportTabs>
    );
};
